import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStep7 = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Done_Check_Checkmark",
	"data-name": "Done, Check, Checkmark",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Group_14026",
		"data-name": "Group 14026",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "Path_11660",
			"data-name": "Path 11660",
			d: "M19.561,6.743,12.005,14.3,8.228,10.521",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}), /* @__PURE__ */ _jsx("path", {
			id: "Path_11661",
			"data-name": "Path 11661",
			d: "M20.595,13.506V18.4a2.1,2.1,0,0,1-2.1,2.1H5.695a2.1,2.1,0,0,1-2.1-2.1V5.6a2.1,2.1,0,0,1,2.1-2.1h6.4",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		})]
	}), /* @__PURE__ */ _jsx("path", {
		id: "Path_11662",
		"data-name": "Path 11662",
		d: "M0,0H24V24H0Z",
		fill: "none"
	})]
});
export default SvgStep7;
